"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgEye = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 15c3.38 0 6.339 1.632 8.855 4.316a20.492 20.492 0 012.25 2.891c.385.596.649 1.065.79 1.346a1 1 0 010 .894c-.141.281-.405.75-.79 1.346a20.492 20.492 0 01-2.25 2.89C30.339 31.369 27.38 33 24 33c-3.38 0-6.339-1.632-8.855-4.316a20.492 20.492 0 01-2.25-2.891 15.188 15.188 0 01-.79-1.346 1 1 0 010-.894c.141-.281.405-.75.79-1.346a20.492 20.492 0 012.25-2.89C17.661 16.631 20.62 15 24 15zm0 2c-2.745 0-5.224 1.368-7.395 3.684A18.513 18.513 0 0014.14 24a18.513 18.513 0 002.464 3.316C18.776 29.632 21.255 31 24 31c2.745 0 5.224-1.368 7.395-3.684A18.513 18.513 0 0033.86 24a18.513 18.513 0 00-2.464-3.316C29.224 18.368 26.745 17 24 17zm0 3a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z",
    id: "eye_svg__a"
  }));
};

var _default = SvgEye;
exports.default = _default;